import {
  Accordion,
  ActionIcon,
  Box,
  Button,
  Divider,
  Flex,
  Group,
  Modal,
  Popover,
  Radio,
  Select,
  Stack,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { useSelector } from "react-redux";
import { decrypt, showInfo } from "../../utils";
import useStyles from "./style";
import moment from "moment";
import "moment-timezone";
import {
  createMar,
  getMar,
  recordResponse,
  updateMedicationAdministration,
} from "../../services";
import { getColor } from "../../pages/Home/Medication";
import { getAllPatientsModal } from "../../services/patient";
import DeleteComponent from "../MedicationModal/DeleteComponent";
import CloseCircle from "../CloseCircle";
import NarcoticBox from "../NarcoticBox";
import { IconChevronDown, IconClock } from "@tabler/icons-react";
import {
  DateInput,
  DatePicker,
  DateTimePicker,
  TimeInput,
} from "@mantine/dates";
import dayjs from "dayjs";
import { getSignatureByIdManual } from "../../services/signature";

const PRNMedicationModal = forwardRef(
  ({ opened, onclose, data, isNew: isNewPRN, date }, ref) => {
    const { classes } = useStyles();
    const { staff } = useSelector((state) => state?.staff);

    const medicines =
      data?.form3?.length > 0
        ? data?.form3
            ?.filter(
              (v) =>
                v?.medicationType?.toUpperCase() === "PRN" && !v?.discontinued
            )
            ?.map((value) => ({
              value: value?.id,
              label: value?.medicationName,
            })) || []
        : [];
    const [isNew, setIsNew] = useState(isNewPRN);
    const [loading, setLoading] = useState(false);
    const [loadingResponse, setLoadingResponse] = useState(false);
    const { selectedClient } = useSelector((state) => state.mar);
    const [selectedMedicine, setSelectedMedicine] = useState(null);
    const { profile } = useSelector((state) => state.profile);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    let userid = profile?.user?.id;
    let userType = profile?.user?.type;
    const _medicationType = data?.medicationType;
    const _upcoming = "upcoming";
    const [state, setState] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState();
    const { allSignature, signature } = useSelector((state) => {
      return state?.signature;
    });
    const [slotDate, setSlotDate] = useState(date || undefined);
    // const [populateStaff, setPopulateStaff] = useState();
    // useEffect(() => {
    //   const staffOptions =
    //     staff?.staffs?.map((item) => ({
    //       value: item?.id,
    //       label: item?.name,
    //     })) || [];

    //   const defaultStaff = profile?.user?.id
    //     ? {
    //         value: profile?.user?.id,
    //         label: profile?.user?.name,
    //       }
    //     : null;

    //   // Add default staff if not already in the list
    //   const isDefaultInList = staffOptions.some(
    //     (opt) => opt.value === defaultStaff?.value
    //   );
    //   const finalOptions =
    //     defaultStaff && !isDefaultInList
    //       ? [defaultStaff, ...staffOptions]
    //       : staffOptions;

    //   setPopulateStaff(finalOptions);
    //   setSelectedStaff(defaultStaff?.value || null);
    // }, [staff, profile]);

    const assignedStaffIds = selectedClient?.staff
      ?.filter((s) => s?.isAssign === true)
      ?.map((s) => s?.staffId);

    const populateStaff = staff?.staffs
      ?.filter((staff) => assignedStaffIds?.includes(staff?.id))
      ?.map((staff) => ({
        label: staff?.name,
        value: staff?.id,
      }));

    useEffect(() => {
      if (isNewPRN) {
        setIsNew(true);
        setSelectedMedicine(null);
      }
    }, [opened, isNewPRN]);

    const form = useForm({
      initialValues: {
        medicine: "",
        reason: "",
        comments: "",
        wasEffective: "",
        staff: data?.staff?.name,
        date: new Date(data?.createdAt),
        time: new Date(data?.createdAt),
        scheduleDate: "",
      },
      validate: {
        // reason: (value) => (value ? null : "Required"),
        // medicine: (value) => (value ? null : "Required"),
        // comments: (value) => (value ? null : "Required"),
        // staff: (value) => (value ? null : "Required"),
        // date: (value) => (value ? null : "Required"),
        // time: (value) => (value ? null : "Required"),
      },
    });
    const form2 = useForm({
      initialValues: {
        wasEffective: "",
      },
      validate: {
        wasEffective: (value) => (value ? null : "Required"),
      },
    });

    const [dateTimeOpened, setDateTimeOpened] = useState(false);
    const [tempDate, setTempDate] = useState(
      form.values.createdAt ? new Date(form.values.createdAt) : null
    );
    const [tempTime, setTempTime] = useState(
      form.values.createdAt ? dayjs(form.values.createdAt).format("HH:mm") : ""
    );

    const [scheduleDateTimeOpened, setScheduleDateTimeOpened] = useState(false);
    const [tempScheduleDate, setTempScheduleDate] = useState(
      form.values.scheduleDate ? new Date(form.values.scheduleDate) : null
    );
    const [tempScheduleTime, setTempScheduleTime] = useState(
      form.values.scheduleDate
        ? dayjs(form.values.scheduleDate).format("HH:mm")
        : ""
    );

    const formatDisplayValue = (date, time) => {
      if (!date) return "";

      if (time) {
        const [hours, minutes] = time.split(":");
        const dateTime = new Date(date);
        dateTime.setHours(parseInt(hours), parseInt(minutes));
        return dayjs(dateTime).format("MMM DD, YYYY - hh:mm A");
      }

      return dayjs(date).format("MMM DD, YYYY");
    };

    const handleDateTimeApply = () => {
      if (tempDate && tempTime) {
        const [hours, minutes] = tempTime.split(":");
        const dateTime = new Date(tempDate);
        dateTime.setHours(parseInt(hours), parseInt(minutes));

        form.setFieldValue("createdAt", dateTime);
        setDateTimeOpened(false);
      } else if (tempDate) {
        form.setFieldValue("createdAt", tempDate);
        setDateTimeOpened(false);
      }
    };

    const handlescheduleDateTimeApply = () => {
      if (tempScheduleDate && tempScheduleTime) {
        const [hours, minutes] = tempScheduleTime.split(":");
        const dateTime = new Date(tempScheduleDate);
        dateTime.setHours(parseInt(hours), parseInt(minutes));

        form.setFieldValue("scheduleDate", dateTime);
        setScheduleDateTimeOpened(false);
      } else if (tempDate) {
        form.setFieldValue("scheduleDate", tempDate);
        setScheduleDateTimeOpened(false);
      }
    };

    const handleDateTimeClear = () => {
      setTempDate(null);
      setTempTime("");
      setDateTimeOpened(false);
    };

    const handleScheduleDateTimeClear = () => {
      setTempScheduleDate(null);
      setTempScheduleTime("");
      setScheduleDateTimeOpened(false);
    };

    useEffect(() => {
      if (dateTimeOpened && !form.values.createdAt) {
        setTempDate(new Date());
        setTempTime(dayjs().format("HH:mm"));
      }
    }, [dateTimeOpened]);


    const handleAdminBy = async (values) => {
      // console.log('values',values);
      
      const date = moment(values?.date);
      const time = moment(values?.time, "hh:mm A");
      const mergedDateTime = moment(date).set({
        hour: time.hours(),
        minute: time.minutes(),
        second: 0,
      });
      const obj = {
        marId: state?._id,
        staff: values?.staff,
        createdAt: mergedDateTime?.toISOString(),
        medicationType:"PRN"

      };
      setBtnLoading(true);
      await updateMedicationAdministration(obj);
      form.reset();
      setIsEditOpen(false);
      setSelectedStaff();
      onclose();
      setBtnLoading(false);
    };

    useImperativeHandle(ref, () => ({
      openView: (data, date) => {
        setIsNew(false);
        setState(data);
        setSlotDate(date);
        setSelectedMedicine(data?.form3);
        form.setFieldValue("quantity", data?.dosage);
        form.setFieldValue("reason", data?.reason);
        form.setFieldValue("otherReason", data?.otherReason);
        form.setFieldValue("comments", data?.comments);
        form2.setFieldValue("wasEffective", data?.wasMedicineEffective);
        // Administration Form
        form.setFieldValue("staff", data?.staff?.id);
        form.setFieldValue("date", new Date(data?.createdAt));
        form.setFieldValue("time", moment(data?.createdAt).format("HH:mm"));
      },
    }));

    const onMedicineChange = (med) => {
      let medicine = data?.form3?.find((v) => v?.id === med);
      form.setFieldValue("medicine", med);
      setSelectedMedicine(medicine);
      form.setFieldValue(
        "quantity",
        String(medicine?.medicationadministered || "0")
      );
    };
    const onSave = async (values) => {

      if (Number(values?.quantity) > 0) {
        let obj = {
          client: selectedClient?.id,
          // date: form.values?.scheduleDate || moment().toISOString(),
           date: form.values?.createdAt || moment().toISOString(),
          createdAt: form.values?.createdAt || moment().toISOString(),
          medicationId: selectedMedicine?.id,
          medicationType: "PRN",
          staff: selectedStaff || userid,
          comments: values?.comments,
          reason: values?.reason,
          medicationName: selectedMedicine?.medicationName,
        };

        if (values?.reason === "Other") {
          obj = { ...obj, otherReason: values?.otherReason };
        }

        const dosage = Number(values?.quantity);

        const payload = {
          ...obj,
          dosage,
        };
        setLoading(true);
        try {
          await createMar(payload);
          form.reset();
          setSelectedStaff();
          setSelectedMedicine(null);
          onclose();
        } catch (error) {
        } finally {
          let calendar_view = localStorage.getItem("calendar_date");
          getMar(calendar_view, selectedClient?.id);
          getAllPatientsModal(true, selectedClient?.id);
          setLoading(false);
        }
      } else {
        alert("Quantity is Required!");
      }
    };

    const onSavePress = async (values) => {
      if (values.wasEffective && state?._id) {
        let payload = {
          id: state?._id,
          wasMedicineEffective: values?.wasEffective,
        };
        setLoadingResponse(true);
        try {
          await recordResponse(payload, () => {
            setLoadingResponse(false);
            showInfo("Response has been recorded");
            form2.reset();
            onclose();
          });
        } catch (error) {
        } finally {
          setLoadingResponse(false);
        }
      }
    };

    const selectedId = isEditOpen && userType !== "staff" ? form?.values?.staff : !isEditOpen && !isNew ? state?.staff?.id : data?.staff?.id
    const staffSignature = allSignature?.find(
      ({ staff, admin }) =>
        (staff && staff === selectedId) ||
        (admin && admin === selectedId)
    );

    // const staffSignature = allSignature?.find(({ staff, admin }) => {
    //   return (
    //     (staff  || (isEditOpen ? form?.values?.staff : data?.staff?.id)) ||
    //     (admin || (isEditOpen ? form?.values?.staff : data?.staff?.id))
    //   );
    // });

    return (
      <>
        <div style={{ overflowX: "auto" }}>
          <div style={{ minWidth: "600px" }}>
            <Modal
              className={classes.medicationModal}
              opened={opened}
              size={1200}
              onClose={() => {
                onclose();
                setIsEditOpen(false);
                setSelectedStaff();
                form.reset();
              }}
              shadow="md"
              overlayProps={{ blur: 3 }}
              radius={"lg"}
              zIndex={2000}
              centered
            >
              <CloseCircle
                onclose={() => {
                  onclose();
                  setIsEditOpen(false);
                  setSelectedStaff();
                  form.reset();
                }}
                marModal={true}
              />
              {isNew ? (
                <div
                  className={classes.upcomingHeader}
                  style={{
                    position: "relative",
                    zIndex: 1000,
                  }}
                >
                  <img
                    src="/assets/images/prn-icon.png"
                    width={50}
                    height={50}
                    alt="prn-icon"
                  />
                  <h2>Administer PRN Medication</h2>
                </div>
              ) : (
                <div
                  style={{
                    background: getColor("PRN")?.dark,
                    position: "relative",
                    zIndex: 1000,
                  }}
                  className={`${classes.title}`}
                >
                  <div className={classes.buttonPRN}>PRN</div>
                  <h2>{selectedMedicine?.medicationName}</h2>
                  {selectedMedicine?.isNarcotic === "Yes" && <NarcoticBox />}
                  <span
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      right: 35,
                    }}
                  >
                    <DeleteComponent
                      data={state}
                      onClose={onclose}
                      type={"prn"}
                    />
                  </span>
                </div>
              )}

              <div className={classes.mainContentWarpper}>
                <div className={classes.mainContent}>
                  <div className={classes.details}>
                    <Flex align={"center"} gap={10} mb={5}>
                      {isNew &&
                        (profile?.user?.role !== "staff" ? (
                          <Select
                            data={populateStaff}
                            value={selectedStaff}
                            placeholder="Select Staff"
                            label="Select Staff"
                            onChange={(e) => setSelectedStaff(e)}
                            rightSection={<IconChevronDown size={16} />}
                            withinPortal={false}
                            dropdownPosition="bottom"
                            // zIndex={5000}
                            // {...form.getInputProps("staff")}
                          />
                        ) : (
                          <Text weight={600} ff={"Inter"} size={"sm"}>
                            {profile?.user?.name}
                          </Text>
                        ))}

                      {/* {isNew && profile?.user?.role !== "staff" ? (
                        <Select
                          data={populateStaff}
                          value={selectedStaff}
                          placeholder="Select Staff"
                          label="Select Staff"
                          onChange={(e) => setSelectedStaff(e)}
                          rightSection={<IconChevronDown size={16} />}
                          withinPortal={false}
                          dropdownPosition="bottom"
                          // zIndex={5000}
                          // {...form.getInputProps("staff")}
                        />
                      ) : (
                        <Text weight={600} ff={"Inter"} size={"sm"}>
                          {profile?.user?.name}
                        </Text>
                      )} */}
                      <p
                        style={{
                          textAlign: "left",
                          marginTop: 0,
                          fontWeight: 600,
                          fontSize: "20px",
                          color: "#5C5C5C",
                        }}
                      >
                        {moment(slotDate).format("MM/DD/YYYY")}
                      </p>
                    </Flex>
                    <div className={classes.head}>
                      {selectedMedicine && (
                        <div className={classes.box}>
                          <h3>
                            {state?.medicineRemaining > 0
                              ? state?.medicineRemaining
                              : "0" || selectedMedicine?.medicineRemaining > 0
                              ? selectedMedicine?.medicineRemaining
                              : "0"}
                          </h3>
                          {(state?.totalMedicine ||
                            selectedMedicine?.totalMedicine) !==
                            "unlimited" && (
                            <p>
                              of{" "}
                              {state?.totalMedicine ||
                                selectedMedicine?.totalMedicine}{" "}
                              <br />
                              Remaining
                            </p>
                          )}
                        </div>
                      )}
                      <div>
                        <div className={`${classes.detailTitle}`}>
                          {isNew ? (
                            <h2>{selectedMedicine?.medicationName}</h2>
                          ) : null}
                          {selectedMedicine?.isNarcotic === "Yes" && isNew && (
                            <Button variant="unstyled">
                              <img src="/assets/images/narcotic.png" alt="" />
                              Narcotic
                            </Button>
                          )}
                        </div>

                        <p>
                          <span className={classes.span1}>
                            {selectedMedicine?.frequency}{" "}
                          </span>{" "}
                          <span className={classes.span2}>
                            {selectedMedicine?.dosage}
                            {selectedMedicine?.unit}{" "}
                            {selectedMedicine?.ingestionMode}{" "}
                            {selectedMedicine?.dosageForm}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className={classes.medicationBox}>
                      {isNew && (
                        <Select
                          id="select-prn-medicine"
                          // classNames="select-prn-medicine"
                          label="PRN Medicine Name"
                          placeholder="Select Medicine"
                          data={medicines}
                          {...form.getInputProps("medicine")}
                          onChange={onMedicineChange}
                          className={classes.prnSelectBox}
                          style={{
                            marginBottom: "10px",
                          }}
                        />
                      )}

                      <Accordion variant="contained">
                        <Accordion.Item
                          value="use"
                          style={{
                            borderRadius: "15px",
                            background: "#F2F2F2",
                            marginBottom: "10px",
                          }}
                        >
                          <Accordion.Control>
                            Use of Medication
                          </Accordion.Control>
                          <Accordion.Panel>
                            {selectedMedicine?.medicationUse}
                          </Accordion.Panel>
                        </Accordion.Item>
                      </Accordion>
                      <Accordion variant="contained">
                        <Accordion.Item
                          value="instruction"
                          style={{
                            borderRadius: "15px",
                            background: "#F2F2F2",
                            marginBottom: "10px",
                          }}
                        >
                          <Accordion.Control>
                            Medication Instruction
                          </Accordion.Control>
                          <Accordion.Panel>
                            {selectedMedicine?.medicationInstruction}
                          </Accordion.Panel>
                        </Accordion.Item>
                      </Accordion>
                    </div>

                    <form
                      className={classes.modalBody}
                      onSubmit={form?.onSubmit((values) => onSave(values))}
                    >
                      <div className={classes.outcome}>
                        <div className={classes.quantity}>
                          <TextInput
                            id="prn-quantity-dispensed"
                            size="xl"
                            radius="xl"
                            type="number"
                            disabled={!isNew}
                            value={form.values.quantity}
                            className={classes.quantityInput}
                            {...form.getInputProps("quantity")}
                            onWheel={(e) => e.target.blur()}
                          />
                          <p>Quantity Dispensed</p>
                        </div>
                      </div>

                      <Select
                        id="select-reason"
                        label="Reason for Administration"
                        data={[
                          { value: "Allergies", label: "Allergies" },
                          { value: "Headache", label: "Headache" },
                          { value: "Congestion", label: "Congestion" },
                          { value: "Cold/Flu", label: "Cold/Flu" },
                          { value: "Constipation", label: "Constipation" },
                          { value: "Cough", label: "Cough" },
                          { value: "Diarrhea", label: "Diarrhea" },
                          {
                            value: "Itchiness/Rash",
                            label: "Itchiness/Rash",
                          },
                          { value: "Fever", label: "Fever" },
                          {
                            value: "Cuts/Abrasions",
                            label: "Cuts/Abrasions",
                          },
                          { value: "Pain", label: "Pain" },
                          { value: "Chafing", label: "Chafing" },
                          { value: "Hemorrhoids", label: "Hemorrhoids" },
                          { value: "Agitation", label: "Agitation" },
                          { value: "Blood Sugar", label: "Blood Sugar" },
                          {
                            value: "Blood Pressure",
                            label: "Blood Pressure",
                          },
                          {
                            value: "Anxiety and panic attacks",
                            label: "Anxiety and panic attacks",
                          },
                          {
                            value: "Nausea and vomiting",
                            label: "Nausea and vomiting",
                          },
                          {
                            value: "Sleep disturbances",
                            label: "Sleep disturbances",
                          },
                          {
                            value: "Asthma attacks",
                            label: "Asthma attacks",
                          },
                          {
                            value: "Allergic reactions",
                            label: "Allergic reactions",
                          },
                          {
                            value: "Migraine relief",
                            label: "Migraine relief",
                          },
                          { value: "Muscle spasms", label: "Muscle spasms" },
                          {
                            value: "Heartburn or acid reflux",
                            label: "Heartburn or acid reflux",
                          },
                          {
                            value: "Flare-ups of chronic conditions",
                            label: "Flare-ups of chronic conditions",
                          },
                          {
                            value: "Menstrual cramps",
                            label: "Menstrual cramps",
                          },
                          { value: "Infections", label: "Infections" },
                          {
                            value: "Dermatological conditions",
                            label: "Dermatological conditions",
                          },
                          {
                            value: "Behavior",
                            label: "Behavior",
                          },
                          {
                            value: "Other",
                            label: "Other",
                          },
                        ]}
                        size="sm"
                        disabled={!isNew}
                        rightSection={
                          <IoIosArrowDown color={"#FBAA0D"} size={25} />
                        }
                        style={{ marginBottom: "15px" }}
                        placeholder="Select Reason"
                        {...form.getInputProps("reason")}
                      />
                      {form.getInputProps("reason")?.value === "Other" ? (
                        <Textarea
                          id="other-reason"
                          label="Other Reason"
                          disabled={!isNew}
                          placeholder="Enter other reason here"
                          {...form.getInputProps("otherReason")}
                        />
                      ) : null}

                      <div
                        className={classes.comments}
                        style={{ marginBottom: "20px" }}
                      >
                        <Textarea
                          id="comments"
                          minRows={6}
                          label="Comments"
                          disabled={!isNew}
                          placeholder="Enter comments here"
                          {...form.getInputProps("comments")}
                        />
                      </div>

                      {isNew && (
                        <Flex
                          justify="space-between"
                          w="100%"
                          wrap="wrap"
                          gap="md"
                        >
                          <Box w="320px">
                            {/* <DateTimePicker
                              label="Select Administration date and time"
                              placeholder="Select Administration date and time"
                              timePickerProps={{
                                withDropdown: true,
                                popoverProps: { withinPortal: false },
                                format: "12h",
                              }}
                              valueFormat="MMM DD, YYYY - hh:mm A"
                              // withAsterisk
                              size="md"
                              // disabled={}
                              maxDate={new Date()}
                              defaultValue={form.values.createdAt}
                              {...form.getInputProps("createdAt")}
                            /> */}
                            <Popover
                              opened={dateTimeOpened}
                              onClose={() => setDateTimeOpened(false)}
                              position="bottom-start"
                              withinPortal={false}
                              shadow="md"
                              radius="md"
                            >
                              <Popover.Target>
                                <TextInput
                                  label="Select Administration date and time"
                                  placeholder="Select Administration date and time"
                                  value={formatDisplayValue(
                                    form.values.createdAt
                                      ? new Date(form.values.createdAt)
                                      : null,
                                    form.values.createdAt
                                      ? dayjs(form.values.createdAt).format(
                                          "HH:mm"
                                        )
                                      : ""
                                  )}
                                  onClick={() => {
                                    if (!tempDate) setTempDate(new Date());
                                    if (!tempTime)
                                      setTempTime(dayjs().format("HH:mm"));
                                    setDateTimeOpened(true);
                                  }}
                                  readOnly
                                  size="md"
                                  styles={{
                                    input: {
                                      cursor: "pointer",
                                    },
                                  }}
                                  error={form.errors.createdAt}
                                />
                              </Popover.Target>

                              <Popover.Dropdown>
                                <Stack spacing="md" p="sm">
                                  <DatePicker
                                    value={tempDate}
                                    onChange={(date) => {
                                      setTempDate(date);
                                    }}
                                    maxDate={new Date()}
                                    size="sm"
                                  />

                                  <TimeInput
                                    label="Select Time"
                                    placeholder="Select time"
                                    value={tempTime}
                                    onChange={(event) => {
                                      setTempTime(event.currentTarget.value);
                                    }}
                                    withAsterisk
                                    size="sm"
                                    icon={<IconClock size={16} />}
                                    format="12"
                                    withDropdown
                                  />

                                  <Group position="apart" mt="md">
                                    <Button
                                      variant="subtle"
                                      color="gray"
                                      size="xs"
                                      onClick={handleDateTimeClear}
                                    >
                                      Clear
                                    </Button>

                                    <Group spacing="xs">
                                      <Button
                                        variant="default"
                                        size="xs"
                                        onClick={() => setDateTimeOpened(false)}
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        size="xs"
                                        onClick={handleDateTimeApply}
                                        disabled={!tempDate}
                                        style={{
                                          backgroundColor: "#fab005",
                                          color: "#000",
                                        }}
                                      >
                                        Apply
                                      </Button>
                                    </Group>
                                  </Group>
                                </Stack>
                              </Popover.Dropdown>
                            </Popover>
                          </Box>

                          <Box w="320px">
                            {/* <DateTimePicker
                              label="Select Schedule date and time"
                              placeholder="Select Schedule date and time"
                              timePickerProps={{
                                withDropdown: true,
                                popoverProps: { withinPortal: false },
                                format: "12h",
                              }}
                              valueFormat="MMM DD, YYYY - hh:mm A"
                              size="md"
                              // disabled={}
                              maxDate={new Date()}
                              defaultValue={form.values.scheduleDate}
                              {...form.getInputProps("scheduleDate")}
                            /> */}
                            <Popover
                              opened={scheduleDateTimeOpened}
                              onClose={() => setScheduleDateTimeOpened(false)}
                              position="bottom-start"
                              withinPortal={false}
                              shadow="md"
                              radius="md"
                            >
                              {/* <Popover.Target>
                                <TextInput
                                  label="Select Schedule date and time"
                                  placeholder="Select Schedule date and time"
                                  value={formatDisplayValue(
                                    form.values.scheduleDate
                                      ? new Date(form.values.scheduleDate)
                                      : null,
                                    form.values.scheduleDate
                                      ? dayjs(form.values.scheduleDate).format(
                                          "HH:mm"
                                        )
                                      : ""
                                  )}
                                  onClick={() => {
                                    if (!tempScheduleDate)
                                      setTempScheduleDate(new Date());
                                    if (!tempScheduleTime)
                                      setTempScheduleTime(
                                        dayjs().format("HH:mm")
                                      );
                                    setScheduleDateTimeOpened(true);
                                  }}
                                  readOnly
                                  size="md"
                                  styles={{
                                    input: {
                                      cursor: "pointer",
                                    },
                                  }}
                                  error={form.errors.scheduleDate}
                                />
                              </Popover.Target> */}

                              <Popover.Dropdown>
                                <Stack spacing="md" p="sm">
                                  <DatePicker
                                    value={tempScheduleDate}
                                    onChange={(date) => {
                                      setTempScheduleDate(date);
                                    }}
                                    maxDate={new Date()}
                                    size="sm"
                                  />

                                  <TimeInput
                                    label="Select Time"
                                    placeholder="Select time"
                                    value={tempScheduleTime}
                                    onChange={(event) => {
                                      setTempScheduleTime(
                                        event.currentTarget.value
                                      );
                                    }}
                                    withAsterisk
                                    size="sm"
                                    icon={<IconClock size={16} />}
                                    format="12"
                                    withDropdown
                                  />

                                  <Group position="apart" mt="md">
                                    <Button
                                      variant="subtle"
                                      color="gray"
                                      size="xs"
                                      onClick={handleScheduleDateTimeClear}
                                    >
                                      Clear
                                    </Button>

                                    <Group spacing="xs">
                                      <Button
                                        variant="default"
                                        size="xs"
                                        onClick={() =>
                                          setScheduleDateTimeOpened(false)
                                        }
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        size="xs"
                                        onClick={handlescheduleDateTimeApply}
                                        disabled={!tempScheduleDate}
                                        style={{
                                          backgroundColor: "#fab005",
                                          color: "#000",
                                        }}
                                      >
                                        Apply
                                      </Button>
                                    </Group>
                                  </Group>
                                </Stack>
                              </Popover.Dropdown>
                            </Popover>
                          </Box>
                        </Flex>
                      )}

                      {isNew && (
                        <div className={classes.saveButton}>
                          <Button loading={loading} type="submit" id="save-prn">
                            <img src="/assets/images/save-icon.png" alt="" />
                            Save
                          </Button>
                        </div>
                      )}
                    </form>
                    {!isNew && !isEditOpen && (
                      <>
                        <div className={classes.info}>
                          <div className="column1">
                            <p>Administered by</p>
                            <h3>{state?.staff?.name}</h3>
                          </div>
                          {staffSignature?.signature ||
                          staffSignature?.signatureImage ? (
                            <div className="column2">
                              <p>Signature by</p>
                              <img
                                src={
                                  decrypt(staffSignature?.signature) ||
                                  decrypt(staffSignature?.signatureImage)
                                }
                                alt="signature"
                                width="180px"
                              />
                            </div>
                          ) : staffSignature?.signatureText ? (
                            <div className="column2">
                              <p>Signature by</p>
                              <Text
                                fz={26}
                                fw={400}
                                lh="normal"
                                ff="Island Moments"
                                color="#171717"
                              >
                                {staffSignature?.signatureText}
                              </Text>
                            </div>
                          ) : null}
                          <div className="column2">
                            <p>Date</p>
                            <h3>
                              {moment(state?.createdAt).format("MM/DD/YYYY")}
                            </h3>
                          </div>
                          <div className="column2">
                            <p>Time</p>
                            <h3>
                              {/* {moment(state?.createdAt).format("hh:mm a")} */}
                              {moment
                                .tz(
                                  moment(state?.createdAt),
                                  profile?.user?.timeZone
                                )
                                .format("hh:mm a")}
                            </h3>
                          </div>
                        </div>
                        <div className={classes.editButton}>
                          <Button
                            onClick={() => {
                              setIsEditOpen(true);
                            }}
                          >
                            Edit
                          </Button>
                        </div>
                      </>
                    )}

                    {isEditOpen && (
                      <form
                        onSubmit={form?.onSubmit((values) =>
                          handleAdminBy(values)
                        )}
                      >
                        <div className={classes.info}>
                          <div className="column1">
                            <div>
                              <p>Administered by</p>
                              {userType !== "staff" ? (
                                <Select
                                  data={populateStaff?.map((data) => {
                                    return {
                                      value: data?.value,
                                      label: data?.label,
                                    };
                                  })}
                                  // style={{ zIndex: -1000 }}
                                  placeholder="Select Staff"
                                  {...form.getInputProps("staff")}
                                />
                              ) : (
                                <h3>{data?.staff?.name}</h3>
                              )}
                            </div>
                          </div>
                          {staffSignature?.signature ||
                          staffSignature?.signatureImage ? (
                            <div className="column2">
                              <p>Signature by</p>
                              <img
                                src={
                                  decrypt(staffSignature?.signature) ||
                                  decrypt(staffSignature?.signatureImage)
                                }
                                alt="signature"
                                width="180px"
                              />
                            </div>
                          ) : staffSignature?.signatureText ? (
                            <div className="column2">
                              <p>Signature by</p>
                              <Text
                                fz={26}
                                fw={400}
                                lh="normal"
                                ff="Island Moments"
                                color="#171717"
                              >
                                {staffSignature?.signatureText}
                              </Text>
                            </div>
                          ) : null}
                          <div className="column2">
                            <p>Date</p>

                            {userType !== "staff" ? (
                              <DateInput
                                placeholder={"mm/dd/yyyy"}
                                rightSection={
                                  <img
                                    style={{ width: "30px" }}
                                    src={"/assets/images/calendar-icon.png"}
                                    alt="Icon"
                                  />
                                }
                                {...form.getInputProps("date")}
                              />
                            ) : (
                              <h3>
                                {moment(data?.createdAt).format("MM/DD/YYYY")}
                              </h3>
                            )}
                          </div>
                          <div className="column2">
                            <p>Time</p>
                            {userType !== "staff" ? (
                              <TimeInput
                                ref={ref}
                                rightSection={
                                  <ActionIcon
                                    variant="subtle"
                                    color="gray"
                                    onClick={() => ref?.current?.showPicker()}
                                  >
                                    <IconClock
                                      style={{
                                        width: rem(16),
                                        height: rem(16),
                                      }}
                                      stroke={1.5}
                                    />
                                  </ActionIcon>
                                }
                                {...form.getInputProps("time")}
                              />
                            ) : (
                              <>
                                {_medicationType !== _upcoming &&
                                  moment(data?.createdAt).isSameOrBefore(
                                    moment()
                                  ) && (
                                    <h3>
                                      {/* {moment(data?.createdAt).format("hh:mm a")} */}

                                      {moment
                                        .tz(
                                          moment(data?.createdAt),
                                          profile?.user?.timeZone
                                        )
                                        .format("hh:mm a")}
                                    </h3>
                                  )}
                              </>
                            )}
                          </div>
                        </div>
                        {userType !== "staff" && (
                          <div className={classes.updateButton}>
                            <div className={classes.editButton}>
                              <Button
                                onClick={() => {
                                  setIsEditOpen(false);
                                }}
                              >
                                Cancel
                              </Button>
                            </div>
                            <Button
                              loading={btnLoading}
                              type="submit"
                              style={btnLoading ? { width: "180px" } : {}}
                            >
                              <img src="/assets/images/save-icon.png" alt="" />
                              Save
                            </Button>
                          </div>
                        )}
                      </form>
                    )}
                  </div>

                  <div className={classes.personInfo}>
                    <img src={decrypt(selectedClient?.imageurl)} alt="client" />
                    <h3>{selectedClient?.name}</h3>
                    <p>{selectedClient?.id?.slice(0, 5)?.toUpperCase()}</p>
                  </div>
                </div>
                {!isNew && (
                  <>
                    <form
                      onSubmit={form2?.onSubmit((values) =>
                        onSavePress(values)
                      )}
                    >
                      <Divider size="lg" my="sm" variant="dashed" />
                      <div className={classes.effectiveContainer}>
                        <div className={classes.wasEffectiveRadioContainer}>
                          <h1>Was the medication effective?</h1>
                          <Radio.Group
                            label=""
                            defaultValue={form2?.values.wasEffective}
                            {...form2.getInputProps("wasEffective")}
                            required
                            withAsterisk
                          >
                            <Group mt="lg">
                              <Radio
                                disabled={
                                  state?.wasMedicineEffective &&
                                  state?.wasMedicineEffective != ""
                                    ? true
                                    : false
                                }
                                value="Yes"
                                label="Yes"
                              />
                              <Radio
                                disabled={
                                  state?.wasMedicineEffective &&
                                  state?.wasMedicineEffective != ""
                                    ? true
                                    : false
                                }
                                value="No"
                                label="No"
                              />
                            </Group>
                          </Radio.Group>
                        </div>
                        <Button
                          loading={loadingResponse}
                          leftIcon={<img src="/assets/images/save.png" />}
                          type="submit"
                          disabled={
                            state?.wasMedicineEffective &&
                            state?.wasMedicineEffective != ""
                              ? true
                              : false
                          }
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </Modal>
          </div>
        </div>
      </>
    );
  }
);

export default PRNMedicationModal;
